import { Box } from "@mui/material";
import { useAnalyticsData } from "modules/customerTickets/hooks/useAnalyticsData";
import React, { FC } from "react";
import {
  COLOR_DARK_GREEN,
  COLOR_DARK_RED,
  COLOR_GREY_10,
} from "shared/theme/colors";
import { ArrowCurvedDownIcon } from "shared/theme/icons/ArrowCurvedDownIcon";
import { ArrowCurvedUpIcon } from "shared/theme/icons/ArrowCurvedUpIcon";
import { ArrowLongForwardIcon } from "shared/theme/icons/ArrowLongForwardIcon";
import { StyledBlackText, StyledComparisonIndicator } from "./styled";

const ComparingSection: FC = () => {
  const {
    lastWeekTotalInquiries,
    thisWeekTotalInquiries,
    weeklyDifferencePercentage,
  } = useAnalyticsData();

  const weeklyCountDifference = thisWeekTotalInquiries - lastWeekTotalInquiries;
  const isIncreased = weeklyCountDifference > 0;
  const isLowerRatio =
    (weeklyDifferencePercentage > 0 && weeklyDifferencePercentage < 1) ||
    weeklyDifferencePercentage === 0;

  const isZeroTicketsTotal =
    thisWeekTotalInquiries === 0 && lastWeekTotalInquiries === 0;

  const renderIcon = () => {
    if (weeklyCountDifference === 0) {
      return <ArrowLongForwardIcon color={COLOR_GREY_10} />;
    } else if (isIncreased) {
      return (
        <ArrowCurvedUpIcon
          color={isLowerRatio ? COLOR_GREY_10 : COLOR_DARK_RED}
        />
      );
    } else if (!isIncreased) {
      return (
        <ArrowCurvedDownIcon
          color={isLowerRatio ? COLOR_GREY_10 : COLOR_DARK_GREEN}
        />
      );
    } else {
      return null;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        columnGap: "8px",
      }}
    >
      {!isZeroTicketsTotal ||
        (lastWeekTotalInquiries > 0 && (
          <StyledComparisonIndicator
            isIncreased={isIncreased}
            isLowerRatio={isLowerRatio}
          >
            {renderIcon()}
            {weeklyDifferencePercentage === 0
              ? "0.0"
              : weeklyDifferencePercentage}
            %
          </StyledComparisonIndicator>
        ))}
      {isZeroTicketsTotal ? (
        <StyledBlackText>+0 inquiries</StyledBlackText>
      ) : (
        weeklyCountDifference !== 0 && (
          <StyledBlackText>
            {`(${isIncreased ? "+" : ""}${weeklyCountDifference} tickets this week)`}
          </StyledBlackText>
        )
      )}
    </Box>
  );
};

export default ComparingSection;
